import { useMemo } from 'react';
import { toAdjacentPairs } from '../../../shared/utils/toAdjacentPairs.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { ModalDialog } from '../modalDialog.tsx';
import { getProtocolChanges } from './getProtocolChanges.ts';
import { ProtocolChangesTile } from './protocolChangesTile.tsx';


interface Props {
    protocols: Protocol[];
    onClose: () => void;
}

export function ProtocolChangesDialog({
    protocols,
    onClose,
}: Props) {
    const { data: equipments, isPending, isError } = trpc.equipments.getAllCustom.useQuery({});

    const protocolPairChanges = useMemo(() => {
        const machineNames = new Map(equipments?.map(it => [it._id!, it.displayName]));
        const sorted = [...protocols].sort((a, b) => b.version! - a.version!);
        const pairs = toAdjacentPairs(sorted);
        const changes = pairs.map(([a, b]) => getProtocolChanges(a, b, machineNames));
        return pairs.map(([a, b], index) => ({
            protocolNew: a,
            protocolOld: b,
            changes: changes[index],
        }));
    }, [protocols, equipments]);


    return (
        <ModalDialog
            frameStyle={{ minWidth: '500px', }}
            isOpen={true}
            onCancel={onClose}
        >
            <h2>Protocol Changes</h2>
            <div>
                {isPending && <div>Loading...</div>}
                {isError && <div>Could not load machine names.</div>}
                {!isPending && protocolPairChanges.map(({ protocolNew, protocolOld, changes }) => (
                    <ProtocolChangesTile
                        key={`${protocolNew.version}-${protocolOld.version}`}
                        protocolNew={protocolNew}
                        protocolOld={protocolOld}
                        changes={changes}
                    />
                ))}
            </div>
        </ModalDialog>
    );
}
